import React, { Dispatch, SetStateAction } from "react";
import { Form } from "react-bootstrap";
import { ActionHandlerFunction, PaginationItem } from "@preveil-api";
import { RequestTab, SettingsUIActionTypes, ApprovalRequestStatusMapping, ApprovalRequestStatus, GlobalConstants, UserRequest } from "src/common";
import { Icon, PaginationDisplay, SimplePagination, ToolbarButton, ToolbarWrapper } from "src/components";

type AllProps = {
  tab: string;
  pagination?: PaginationItem;
  handleAction: ActionHandlerFunction;
  confirmDelete: Function;
  checked_list: UserRequest[];
  setCheckedList: Dispatch<SetStateAction<UserRequest[]>>;
  approval_requests: UserRequest[];
  setShow: Dispatch<SetStateAction<boolean>>;
  is_approval: boolean;
  is_loading: boolean;
};

/* Description: Toolbar for approval requests: approvals, recovery group requests and admin approval requests. 
Changes depending on which component and also which tab - pending or history. */
function ApprovalRequestsToolbarComponent(props: AllProps) {
  const {
    tab,
    pagination,
    handleAction,
    confirmDelete,
    checked_list,
    setCheckedList,
    approval_requests,
    setShow,
    is_approval,
    is_loading
  } = props;

  /* Description: Changes the filter status when the user selects a different option. - For the history tab */
  function handleOptionSelect(e: React.ChangeEvent<HTMLSelectElement>) {
    setShow(false);
    setCheckedList([]);
    const value = e.target.value;
    handleAction({
      actionType: SettingsUIActionTypes.UpdateFilterStatus,
      params: value,
    });
  };

  function isLastPage(pagination: PaginationItem) {
    return (
      (pagination.pageIndex + 1) * GlobalConstants.REQUESTS_PER_PAGE_COUNT > pagination.totalRows ||
      (approval_requests.length === GlobalConstants.REQUESTS_PER_PAGE_COUNT &&
        (pagination.pageIndex + 1) * GlobalConstants.REQUESTS_PER_PAGE_COUNT ===
        pagination.totalRows) ||
      approval_requests.length === 0
    );
  }

  function refresh() {
    setShow(false);
    setCheckedList([]);
    handleAction({
      actionType: SettingsUIActionTypes.Refresh,
      params: tab,
    });
  }

  const left_content = tab === RequestTab.history ? (
    <Form.Select size="sm" onChange={handleOptionSelect}>
      <option value={ApprovalRequestStatus.approved}>{ApprovalRequestStatusMapping.approved}</option>
      <option value={ApprovalRequestStatus.denied}>{ApprovalRequestStatusMapping.denied}</option>
    </Form.Select>
  ) : undefined;

  const pagination_el = tab === RequestTab.history && !!pagination && approval_requests.length > 0
    ? <SimplePagination
        isFirst={pagination.pageIndex === 0}
        isLast={isLastPage(pagination)}
        handleAction={handleAction} />
    : <></>;

  const pagination_info = !!pagination && !is_loading ? <PaginationDisplay pagination={pagination} /> : <></>;

  return (
    <ToolbarWrapper
      leftContent={left_content}
      pagination={pagination_el}
      paginationInfo={pagination_info}
      refreshAction={refresh}
      refreshTooltipContent="Refresh Approval Requests"
      isLoading={is_loading}
    >
      {tab === RequestTab.pending && !is_approval ? <ToolbarButton
        disabled={checked_list.length === 0}
        onClick={() => confirmDelete()}
        ariaLabel="Delete Selected"
        tooltipContent="Delete Selected">
        <Icon className="ficon-trash-2" />
      </ToolbarButton> : <></>}
    </ToolbarWrapper>
  );
}

export default React.memo(ApprovalRequestsToolbarComponent);
